import React from 'react'
import {
	Button
} from 'reactstrap'

import ModalIngredientEdit from '~/modules/modals/ingredients/edit.jsx'
import ModalIngredientDelete from '~/modules/modals/ingredients/delete.jsx'


// export default class RecipeIngredientsModalList extends Reflux.Component {
export default class RecipeIngredientsModalListRow extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			isEditing: false
		}
	}

	toggleEdit = () => {
		this.setState({ isEditing: !this.state.isEditing })
	}

	render() {
		return (this.state.isEditing === true)
			? (
				<ModalIngredientEdit
					ingredientID={this.props.ingredientID}
					ingredient={this.props.ingredient}
					cancelFunction={this.toggleEdit}
				/>
			)
			: (
				<tr>
					<td>{this.props.ingredient}</td>
					<td>
						<Button
							onClick={this.toggleEdit}
							color="primary"
							block
						>
							Edit
						</Button>
					</td>
					<td>
						<ModalIngredientDelete
							ingredientID={this.props.ingredientID}
						/>
					</td>
				</tr>
			)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredients/listRow.jsx